import { useCallback } from "react";

import { RequiredAnswerSection } from "../required-answer-section";

type UseAllowRoomChangeTermsProps = {
  canSelectAllowRoomChange: boolean;
  allowRoomChange: boolean | undefined;
  setValue: (
    name: "allowRoomChange",
    value: boolean,
    options?: { shouldValidate?: boolean },
  ) => void;
  disabled?: boolean;
};

export function useAllowRoomChangeTerms({
  canSelectAllowRoomChange,
  allowRoomChange,
  setValue,
  disabled = false,
}: UseAllowRoomChangeTermsProps) {
  const renderAllowRoomChangeTerms = useCallback(() => {
    if (!canSelectAllowRoomChange) {
      return null;
    }
    return (
      <AllowRoomChangeTerms
        allowRoomChange={allowRoomChange}
        setValue={setValue}
        disabled={disabled}
      />
    );
  }, [canSelectAllowRoomChange, allowRoomChange, setValue, disabled]);

  return {
    renderAllowRoomChangeTerms,
  };
}

function AllowRoomChangeTerms({
  allowRoomChange,
  setValue,
  disabled,
}: {
  allowRoomChange: boolean | undefined;
  setValue: (
    name: "allowRoomChange",
    value: boolean,
    options?: { shouldValidate?: boolean },
  ) => void;
  disabled: boolean;
}) {
  return (
    <RequiredAnswerSection
      title="部屋変更へのご協力のお願い"
      actionArea={
        <div className="flex gap-[24px]">
          <label className="flex cursor-pointer items-center gap-[10px] text-[16px] font-normal tracking-[0.15px]">
            <input
              type="radio"
              name="allowRoomChange"
              className="accent-sorange h-[24px] w-[24px] cursor-pointer"
              checked={allowRoomChange === true}
              onChange={() =>
                setValue("allowRoomChange", true, {
                  shouldValidate: true,
                })
              }
              disabled={disabled}
              data-testid="allow-room-change-option-true"
            />
            はい
          </label>
          <label className="flex cursor-pointer items-center gap-[10px] text-[16px] font-normal tracking-[0.15px]">
            <input
              type="radio"
              name="allowRoomChange"
              className="accent-sorange h-[24px] w-[24px] cursor-pointer"
              checked={allowRoomChange === false}
              onChange={() =>
                setValue("allowRoomChange", false, {
                  shouldValidate: true,
                })
              }
              disabled={disabled}
              data-testid="allow-room-change-option-false"
            />
            いいえ
          </label>
        </div>
      }
    >
      <p>
        より多くの方に連泊でのご滞在をお楽しみいただけるよう、同じ日程・拠点・施設・オプションにて、別のお部屋へ変更させていただく場合があります。
      </p>
      <p className="mt-[1em]">
        変更はチェックインの2日前までに行い、その後メールでご案内いたします。
      </p>
      <p className="mt-[1em]">あらかじめご了承いただけますか？</p>
    </RequiredAnswerSection>
  );
}
